<div class="ziro-admin-page-content">
  <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
  <div class="col-md-10 offset-md-1" [hidden]="isLoading">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item>
        <span [innerHTML]="'tkey;admin.microsoft.dubber_management.about.content' | escapeHtml"></span>
      </ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>
    <ziro-collapsible-section-card [isSwitchHidden]="true" [isCollapsible]="false">
      <ziro-text [fieldId]="'username'"></ziro-text>
      <ziro-text [fieldId]="'password'"></ziro-text>
      <ziro-text [fieldId]="'url'"></ziro-text>
    </ziro-collapsible-section-card>
  </div>
</div>

<ziro-bottom-nav></ziro-bottom-nav>
